import { CharacterRestrictedEllipsedTypography, LineRestrictedEllipsedTypography, PromoBar } from './src-styledComponents-couponComponent.styles.js';
import { FlexBox } from '@vp/swan';
import React from 'react';
import { fullWidthInclusivePages } from './src-constants-pageId.js';
import { useScopedBaseConfig } from './src-contexts-CouponCalloutConfig.context.js';
import { useCouponDetailsStore } from './src-store-couponDetails.store.js';
import { CouponCode } from './src-components-CouponDisplay-CouponCode.js';

const PMTDisplayMessage = ({ queryKey }) => {
  const { pageId } = useScopedBaseConfig();
  const fullWidth = fullWidthInclusivePages.includes(pageId);
  const productCouponDetails = useCouponDetailsStore((state) => state.data[pageId]?.couponDetails?.productCouponData?.[queryKey]);
  const ElippsedTypographyComponent = fullWidth ? CharacterRestrictedEllipsedTypography : LineRestrictedEllipsedTypography;
  const renderDisplayMsgForCoupon = /* @__PURE__ */ React.createElement(ElippsedTypographyComponent, { fontWeight: "normal", margin: 0 }, productCouponDetails?.messaging.displayMessage, "\xA0");
  return /* @__PURE__ */ React.createElement(PromoBar, null, /* @__PURE__ */ React.createElement(
    FlexBox,
    {
      flexWrap: "wrap",
      textAlign: "left",
      flexDirection: "row"
    },
    renderDisplayMsgForCoupon,
    /* @__PURE__ */ React.createElement(CouponCode, { queryKey })
  ));
};

export { PMTDisplayMessage };
//# sourceMappingURL=src-components-CouponDisplay-PMTDisplayMessage.js.map
